import axiosConfig from "./axiosConfig";
import { SolarEdgeAlertAcknowledgement } from "./getSiteHealthEvents";

export interface AcknowledgeSolarEdgeAlertRequest {
  note: string;
  /** ISO datetime; once passed the alert returns and is announced as new. */
  reviewAt?: string | null;
}

const acknowledgeSolarEdgeAlert = async (
  authToken: string,
  siteId: string,
  alertId: number,
  request: AcknowledgeSolarEdgeAlertRequest
): Promise<SolarEdgeAlertAcknowledgement> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/health/solaredge-alerts/${alertId}/acknowledgement`,
    request,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default acknowledgeSolarEdgeAlert;
